import { User } from "./user-model";

export class Profile {
    id: number;
    user: User;
    name: string;
    status: string;
    mood: string;
    eartefactId: number;
}

export class Message {
    id: number;
    profileFrom: Profile;
    profileTo: Profile;
    message: string;
    sended: string;
    group: string;
    readed: string;
}

/**
 * Pagina de mensagens retornada por ProfileProvider.getMessagesPage.
 * "messages" ja vem na ordem cronologica (mais antiga -> mais recente).
 * Para carregar a pagina anterior, use o "id"/"sended" da mensagem mais antiga
 * da pagina atual.
 */
export class MessagePage {
    messages: Message[];
    hasMore: boolean;
}

/**
 * Um resultado de ProfileProvider.searchMessages: UMA mensagem que casou com o
 * termo, o contato do outro lado da conversa e quem a enviou.
 *
 * A mesma conversa pode aparecer varias vezes: se a pessoa escreveu "oi" tres
 * vezes, saem tres MessageSearchResult com o mesmo profileId. Quem reagrupa por
 * profileId e a tela (ChatChatsSidenavComponent.messageMatches).
 *
 * Nao traz nome nem avatar de proposito - a tela ja tem a lista de contatos
 * carregada e resolve esses dados pelo profileId.
 */
export class MessageSearchResult {
    profileId: number;
    message: string;
    sended: string;

    /** Id da mensagem devolvida, para abrir a conversa nela. */
    messageId: number;

    /** Perfil que enviou - define de que lado o balao e desenhado. */
    profileFromId: number;
}


export class ProfileChatTo{
    profile: Profile;
    id: number;
    name:string;
    userId: number;
    status: string;
    avatar: string;
    unread: number;
}
